import api from './api'

export default {

    async top() {
        return api.request('/competition')
    },
    async table(competitionId, seasonId) {

        return api.request(
            `/competition/${competitionId}/season/${seasonId}/standings`
        );

    },

    async matches(id, seasonId = null) {

        const query = seasonId ? `?seasonId=${seasonId}` : '';

        return api.request(`/competition/${id}/matches${query}`);

    }

}